<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <whitelist-table></whitelist-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import whitelistTable from './WhitelistTable.vue'

  export default {
    name: 'withdraw-whitelist',
    components: {whitelistTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/payment/withdraw/Whitelist.vue